import React from "react";
import { Button, Box } from "@mui/material";
import fondo from "../../assets/svg/fondo.png";

export default function Dashboard() {

   // Get the current URL
   const currentUrl = window.location.href;

   // Remove all query parameters from the URL
   const updatedUrl = removeQueryParameters(currentUrl);
 
   // Replace the current history entry with the updated URL
   window.history.replaceState({}, document.title, updatedUrl);
 
   // Function to remove all query parameters from the URL
   function removeQueryParameters(url : string) {
     // Find the index of the '?' character in the URL
     const index = url.indexOf('?');
     
     // If the '?' character is found, remove everything after it
     if (index !== -1) {
       return url.substring(0, index);
     }
     
     // If no '?' character is found, return the original URL
     return url;
   }
   
  return (
    
      <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
        <img src={fondo} alt="Logo" width="400" height="550" />
      </Box>
  );
}
